import { SearchResponseItemProps } from '../../SearchResponseItem';

export function sortSearchesByStatus(
  searchResponses: SearchResponseItemProps[]
) {
  return searchResponses.sort((itemA) => {
    if (itemA.status === 'new') {
      return -1;
    } else if (itemA.status === 'rejected') {
      return 1;
    }
    return 0;
  });
}
